import { createAuthFileDownloadQuery } from '../auth-http-client';

export type DownloadAccountReportQueryParams = {
	accountIds: number[];
	currencies: string[];
	dateFrom: string;
	dateTo: string;
	timeZone: number;
};

export const createDownloadAccountReportQuery = () =>
	createAuthFileDownloadQuery<DownloadAccountReportQueryParams>({
		url: '/report/account/download',
		fileName: (params) => `account-report-${params.dateFrom}-${params.dateTo}.xlsx`,
	});
